
import { useEffect, useRef } from 'react';
import '../styles/InfoModal.css';

export default function InfoModal({
  open,
  onClose,
  heading,
  config,
  advanced,
  download,
  codelineage,
  title,
  type
}) {
  const modalRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  // Focus trap: focus the modal when opened
  useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.focus();
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="clm-backdrop" onClick={onClose} >
      <div
        className="clm-modal"
        // role="dialog"
        // aria-modal="true"
        // aria-labelledby="clm-title"
        // onClick={(e) => e.stopPropagation()}
        // tabIndex={-1}
        ref={modalRef}
      >
        {/* Close button */}
        <button className="clm-close-btn" onClick={onClose}></button>
        {/* Left gradient panel */}
        <div className="clm-left">
          <div className="clm-left-gradient" />
          <div className="clm-left-content">
            {type === 1 &&
              <i className='CodeLineageIcon2'></i>
            }
            {type === 2 &&
              <i className='KBIcon2'></i>
            }
            {type === 3 &&
              <i className='AdvancedIcon2'></i>
            }
            <div className="clm-left-title">{title}</div>
          </div>
        </div>

        {/* Right content */}
        <div className="clm-right">
          <h2 id="clm-title" className="clm-heading">
            {heading}
          </h2>
          <div className="clm-subheading">Make use of the following :</div>
          <ul className="clm-links">
            {download &&
              <li>
                <span className="clm-link-icon DownloadIcon"  />
                {download}
              </li>
            }
            {advanced &&
              <li>
                <span className="clm-link-icon AdvancedIcon"  />
                {advanced}
              </li>
            }
            {codelineage &&
              <li>
                <span className="clm-link-icon CodeLineageIconSM"  />
                {codelineage}
              </li>
            }
            {config &&
              <li>
                <span className="clm-link-icon ConfigureIcon"  />
                {config}
              </li>
            }

          </ul>
        </div>
      </div>
    </div>
  );
}

